import React from 'react'
import {
    Box,
    Button,
    Text,
    useMultiStyleConfig,
    Flex,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CloseIcon} from '../../icons'
import PropTypes from 'prop-types'
import {useLocation, useHistory} from 'react-router-dom/cjs/react-router-dom.min'
import {
    getSelectedFiltersFromUrl,
    clearAllFilters,
    removeFilter,
} from '../utils/recipe-search-params-utils'
import {FormattedMessage} from 'react-intl'

const SelectedFilters = ({filters}) => {
    const location = useLocation()
    const history = useHistory()
    const styles = useMultiStyleConfig('Filters', {variant: 'selectedFilterButton'})
    const selectedFilters = getSelectedFiltersFromUrl(location, filters)
    // Flatten the selectedFilters object to an array of filter values
    const flattenedFilters = Object.values(selectedFilters).flat()

    const handleClearFilters = () => {
        if (!location || !history) return
        clearAllFilters(location, history)
    }
    const handleRemoveFilter = (filter) => {
        if (!filter || !location || !history) return
        removeFilter(location, history, filter)
    }

    return (
        <>
            {flattenedFilters.length > 0 && (
                <Flex {...styles?.selectedRefinementsContainer} maxWidth="100%" overflowX="auto">
                    {flattenedFilters.map((filter, idx) => (
                        <Box key={idx} marginLeft={0} marginRight={0} flexShrink={0} height="100%">
                            <Button
                                {...styles.selectedRefinementsButton}
                                onClick={() => {
                                    handleRemoveFilter(filter)
                                }}
                            >
                                <Box {...styles.selectedRefinementsIconBox}>
                                    <CloseIcon {...styles.filterIcon} />
                                </Box>
                                <Text {...styles.filterText} alignSelf="stretch">
                                    {filter?.contentstackValue}
                                </Text>
                            </Button>
                        </Box>
                    ))}
                    {flattenedFilters.length > 0 && (
                        <Box {...styles?.removeAllButtonContainer}>
                            <Button
                                {...styles.filterButton}
                                {...styles.removeAllButton}
                                onClick={handleClearFilters}
                            >
                                <Text textStyle="body-small" fontWeight="normal">
                                    <FormattedMessage
                                        id="selected_refinements.action.clear_all"
                                        defaultMessage="Remove All"
                                    />
                                </Text>
                            </Button>
                        </Box>
                    )}
                </Flex>
            )}
        </>
    )
}

SelectedFilters.propTypes = {
    filters: PropTypes.array,
    selectedFilters: PropTypes.object,
    setSelectedFilters: PropTypes.func,
    setRecipes: PropTypes.func,
}

export default SelectedFilters
